import React from 'react';

import {ResponsiveElementGroup} from 'src/components/responsive-element-group';
import {FormItemSkeleton, FormSectionSkeleton, SkeletonItem} from 'src/components/skeleton';

export const AccountLimitsSectionSkeleton = () => (
    <FormSectionSkeleton labelWidth={138}>
        <ResponsiveElementGroup>
            <FormItemSkeleton labelWidth={173}>
                <SkeletonItem width={300} height={32}/>
            </FormItemSkeleton>
            <FormItemSkeleton labelWidth={160}>
                <SkeletonItem width={300} height={32}/>
            </FormItemSkeleton>
            <FormItemSkeleton labelWidth={126}>
                <SkeletonItem width={300} height={32}/>
            </FormItemSkeleton>
        </ResponsiveElementGroup>
    </FormSectionSkeleton>
);
